
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32"
  },
  "children": [
    {
      "tag": "title",
      "children": [
        {
          "text": "volume-fill"
        }
      ]
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M16.432 4.362c0.592-0.355 1.347 0.070 1.347 0.762v21.75c0 0.691-0.755 1.117-1.347 0.762l-7.12-4.272c-0.275-0.166-0.592-0.253-0.915-0.253h-4.842c-0.982 0-1.779-0.794-1.779-1.779v-10.666c0-0.982 0.794-1.779 1.779-1.779h4.838c0.323 0 0.64-0.086 0.915-0.253l7.123-4.272zM22.026 9.088c1.846 1.846 2.864 4.301 2.864 6.915 0 2.611-1.018 5.066-2.864 6.912-0.166 0.166-0.394 0.262-0.63 0.262-0.227 0-0.454-0.086-0.627-0.262-0.346-0.346-0.346-0.909 0-1.258 1.514-1.51 2.342-3.517 2.342-5.654s-0.829-4.147-2.342-5.658c-0.346-0.346-0.346-0.909 0-1.258s0.909-0.349 1.258 0zM25.798 5.315c2.854 2.854 4.426 6.65 4.426 10.685s-1.571 7.83-4.426 10.685c-0.166 0.166-0.394 0.262-0.63 0.262-0.227 0-0.454-0.086-0.627-0.262-0.346-0.346-0.346-0.909 0-1.258 2.518-2.518 3.904-5.866 3.904-9.427s-1.386-6.909-3.904-9.43c-0.346-0.346-0.346-0.909 0-1.258 0.346-0.346 0.909-0.346 1.258 0.003z"
      }
    }
  ]
})
    }
  